import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

/**
 * Bloque l'accès aux routes réservées aux utilisateurs internes.
 * Les utilisateurs externes sont redirigés vers /project-management.
 */
export const internalOnlyGuard = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isExternalUser) {
    return router.createUrlTree(['/project-management']);
  }

  return true;
};
